import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-bulk-containers',
    templateUrl: './bulk-containers.component.html',
    styleUrls: ['./bulk-containers.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BulkContainersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
